import { connect } from 'react-redux';
import { loadEligiblePlayers, loadEligibleTeamOfficials, loadExtendedEligiblePlayers, loadExtendedEligibleTeamOfficials } from '../../store/actions/eligibles';
import { changePage, isLoading } from '../../store/actions/app';
import { getRosters } from '../../util/reducer-helpers';
import { supports } from '../../util/context';
import Eligibles from '../../components/Pages/Eligibles';

const mapStateToProps = ( state, props ) => {

    // console.log( 'containers.Pages.Eligibles.mapStateToProps', state, props );

    const rosters      = getRosters( state );
    const getEligibles = ( key, rosterKey ) => {

        let filteredEligibles = [];
        let eligibles         = state.items[ key ] && ( props.teamId in state.items[ key ] ) ? state.items[ key ][ props.teamId ] : null;
        let lastUpdate        = null;

        if ( eligibles ) {

            lastUpdate = eligibles.lastUpdate;

            if ( eligibles.items && eligibles.items.length ) {

                let roster = null;

                if ( state.items.games.activeItem.homeTeam.id === props.teamId ) {

                    roster = rosters[ 'mergedHome' + rosterKey ];

                } else if ( state.items.games.activeItem.awayTeam.id === props.teamId ) {

                    roster = rosters[ 'mergedAway' + rosterKey ];

                }

                filteredEligibles = eligibles.items.filter( eligible => { const found = roster ? roster.find( e => e.id === eligible.id ) : null; return ( found ? false : true ); } );

            }

        }

        return { lastUpdate, items: filteredEligibles };

    };

    const cProps = {

        activeGame:        state.items.games.activeItem,
        context:           state.auth.context,
        eligiblePlayers:   getEligibles( 'eligiblePlayers', 'Roster' ),
        loading:           state.app.loading,
        suspensionSetting: rosters.rosters && rosters.rosters.items && rosters.rosters.items.suspensionSetting,
        token:             state.auth.token

    };

    if ( supports( state.auth.context, 'extendedRoster' )                                                    ) { cProps.extendedEligiblePlayers       = getEligibles( 'extendedEligiblePlayers',       'Roster'        ); }
    if ( supports( state.auth.context, 'teamOfficials' )                                                     ) { cProps.eligibleTeamOfficials         = getEligibles( 'eligibleTeamOfficials',         'TeamOfficials' ); }
    if ( supports( state.auth.context, 'extendedRoster' ) && supports( state.auth.context, 'teamOfficials' ) ) { cProps.extendedEligibleTeamOfficials = getEligibles( 'extendedEligibleTeamOfficials', 'TeamOfficials' ); }

    return cProps;

};

const mapDispatchToProps = dispatch => {

    return {
        onChangePage:                        route => dispatch( changePage( route ) ),
        onLoadEligiblePlayers:               ( context, token, gameId, teamId ) => dispatch( isLoading( true ) ) && dispatch( loadEligiblePlayers(               context, token, gameId, teamId ) ),
        onLoadEligibleTeamOfficials:         ( context, token, gameId, teamId ) => dispatch( isLoading( true ) ) && dispatch( loadEligibleTeamOfficials(         context, token, gameId, teamId ) ),
        onLoadExtendedEligiblePlayers:       ( context, token, gameId, teamId ) => dispatch( isLoading( true ) ) && dispatch( loadExtendedEligiblePlayers(       context, token, gameId, teamId ) ),
        onLoadExtendedEligibleTeamOfficials: ( context, token, gameId, teamId ) => dispatch( isLoading( true ) ) && dispatch( loadExtendedEligibleTeamOfficials( context, token, gameId, teamId ) )
    };

};

export default connect( mapStateToProps, mapDispatchToProps )( Eligibles );